export class NavigationDesactived {

    constructor()
    {
        const votreExpert = document.querySelector('.votreExpert');

        votreExpert.firstChild.addEventListener('click', (e) => {
            e.preventDefault();
        })

    }

}


// WEBPACK FOOTER //
// ./js/util/navDesactived.js